import React, { useState } from 'react'
import logo from '../logo.png';
import "./header.scss"
import { useNavigate } from 'react-router-dom';
import 'boxicons'
function Header() {
  const navigate = useNavigate()
  const [isOpen,setIsOpen] = useState(false)
  const [isCloseAnimation,setIsCloseAnimation] = useState(false)
  const handleOpen = () => {
    setIsOpen(true)
  }
  const handleClose = () => {
    setIsCloseAnimation(true)
    setTimeout(() => {
      setIsOpen(false)
      setIsCloseAnimation(false)
    },700)
  }

  const handleNavigate = (route) => {
    navigate(route)
    setIsCloseAnimation(true)
    setTimeout(() => {
      setIsOpen(false)
      setIsCloseAnimation(false)
    },500)
  }
  return (
    <header>
      <img onClick={() => navigate('/')} src={logo} alt="" />
      {/* <box-icon onClick={handleOpen} name='menu'></box-icon> */}
      {isOpen && (
        <div className="list_hamburger" style={isCloseAnimation ? {animation: 'close 0.5s alternate ease-in-out forwards'} : {}}>
          <box-icon onClick={handleClose} name='x'></box-icon>
          <img onClick={() => handleNavigate('/')} src={logo} alt="" />
      {/* {window.location.pathname.includes('kontakt') ? <button onClick={() => handleNavigate('/')}>Zurück</button> : <button onClick={() => handleNavigate('/kontakt')}>Kontakt</button>} */}
      {/* {window.location.pathname.includes('adresse') ? <button onClick={() => handleNavigate('/')}>Zurück</button> : <button onClick={() => handleNavigate('/adresse')}>Adresse</button>} */}
      {(window.location.pathname.includes('aboutUs') || window.location.pathname.includes('impressum') || window.location.pathname.includes('jobs')) && <button onClick={() => handleNavigate('/')}>Zurück</button>}
      </div>
      )}
      
      <div className="btns">
        {(window.location.pathname.includes('aboutUs') || window.location.pathname.includes('impressum') || window.location.pathname.includes('jobs')) && <button onClick={() => handleNavigate('/')}>Zurück</button>}
        {/* {window.location.pathname.includes('kontakt') ? <button onClick={() => navigate('/')}>Zurück</button> : <button onClick={() => navigate('/kontakt')}>Kontakt</button>} */}
        {/* {window.location.pathname.includes('adresse') ? <button onClick={() => navigate('/')}>Zurück</button> : <button onClick={() => navigate('/adresse')}>Adresse</button>} */}
      </div>
    </header>
  )
}

export default Header